import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
    checkDoesObjectHaveContent,
    deepCopy,
    fetchTimeout,
    BaseURL,
    getCookie,
    setCookie,
} from "../components/Common";
import { API_BASE } from "../AppConfig";
import BSL_Select from "../components/BSL_Select";
import ManageBusiness from "../components_main/ManageBusiness/ManageBusiness";
import { updateBusiness, loadUser } from "../redux_store/appState";
import { checkJobStateValidationSchema } from "../redux_store/jobState";

import * as BSL_Common from "../components/BSL_CommonControls";
import { LinearProgress } from "@material-ui/core";
import BSL_Button from "../components/BSL_Button";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import BSL_TextInput from "../components/BSL_TextInput";
import Message from "../components/Message";
import BSL_Dialog from "../components/BSL_Dialog";

const useStyles = makeStyles({
    root: {
        height: "90%",
        overflow: "auto",
    },
});

export default function ManageUsers(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [intialise, setIntialise] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [exporting, setExporting] = React.useState(false);
    const [currentBusinessId, setCurrentBusinessId] = React.useState("");
    const [showDeleteBusiness, setShowDeleteBusiness] = React.useState(false);
    const [showArchiveBusiness, setShowArchiveBusiness] = React.useState(false);
    const [currentBusiness, setCurrentBusiness] = React.useState(null);
    const [currentBusinessUsers, setCurrentBusinessUsers] = React.useState(null);
    const [currentUserId, setCurrentUserId] = React.useState(null);
    const [currentUser, setCurrentUser] = React.useState(null);
    const [businessList, setBusinessList] = React.useState([]);
    const [allbusinessList, setAllBusinessList] = React.useState([]);
    const [errorStateBusiness, setErrorStateBusiness] = React.useState({});
    const [errorStateUser, setErrorStateUser] = React.useState({});
    const [showMessage, setShowMessage] = React.useState(false);
    const [showCodeGenerator, setShowCodeGenerator] = React.useState(false);
    const [businessName, setBusinessName] = React.useState("");
    const [codeSuggestion, setCodeSuggestion] = React.useState("---");
    const [saveButtonDisabled, setSaveButtonDisabled] = React.useState(false);

    const validationSchema = useSelector((state) => state.config.validationSchema);
    const user = useSelector((state) => state.app.user);

    let isAdmin = true;

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "business?isAdmin=" + isAdmin;
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    
                    setAllBusinessList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    
                    setAllBusinessList([]);
                });
        }
    }, [intialise]);

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "business/";
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    
                    setBusinessList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    
                    setBusinessList([]);
                });
        }
    }, [intialise]);

    React.useEffect(() => {
        if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache"))
            return;
        if (currentBusinessId) {
            let api_url = API_BASE() + "business/" + currentBusinessId;
            setLoading(true);
            setCurrentBusiness(null);
            setCurrentBusinessUsers(null);
            setCurrentUserId(null);
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    
                    setCurrentBusiness(json);

                    //get users
                    api_url = API_BASE() + "users/" + currentBusinessId;
                    fetchTimeout(api_url, {
                        method: "GET",
                    })
                        .then((response) => response.json())
                        .then((json) => {
                            
                            setCurrentBusinessUsers(json);
                            setLoading(false);
                        })
                        .catch((e) => {
                            
                        });
                })
                .catch((e) => {
                    
                    setLoading(false);
                });
        } else {
            setCurrentBusiness(null);
        }
    }, [currentBusinessId]);

    const archiveBusiness = () => {
        let archivedBusiness = deepCopy(currentBusiness);
        if (archivedBusiness.Status === "ARCHIVED") archivedBusiness.Status = "ACTIVE";
        else archivedBusiness.Status = "ARCHIVED";
        setCurrentBusiness(archivedBusiness);
        saveBusinessData(archivedBusiness);
        setShowArchiveBusiness(false);
    };

    const deleteBusiness = () => {
        let api_url = API_BASE() + "business/" + currentBusinessId;
        setLoading(true);
        fetchTimeout(api_url, {
            method: "DELETE",
        })
            .then((response) => response.json())
            .then((json) => {
                
                setLoading(false);
                setIntialise(false);
            })
            .catch((e) => {
                
                setLoading(false);
                setIntialise(false);
            });
        setCurrentBusiness(null);
        setShowDeleteBusiness(false);
    };

    const saveBusiness = () => {
        saveBusinessData(currentBusiness);
    };
    const saveBusinessData = (businessData = null) => {
        if (currentBusinessId) {
            let errors_has_content = checkDoesObjectHaveContent(errorStateBusiness);

            if (errors_has_content) {
                setShowMessage({
                    type: "error",
                    message: "Error: Business " + errors_has_content.key + " " + errors_has_content.value,
                });
                return;
            }

            if (businessData === null) businessData = deepCopy(currentBusiness);

            let api_url = API_BASE() + "business/" + currentBusinessId;
            setLoading(true);
            fetchTimeout(api_url, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(businessData),
            })
                .then((response) => response.json())
                .then((json) => {
                    
                    setLoading(false);
                    setCurrentBusinessId(businessData.id);
                    setIntialise(false);
                    if (currentBusinessId === user.BusinessDetails.id) {
                        dispatch(updateBusiness(businessData));
                    }
                    setShowMessage({
                        type: "Success",
                        message: "Success updating business details",
                    });
                })
                .catch((e) => {
                    setShowMessage({
                        type: "error",
                        message: "Error saving business details",
                    });

                    setLoading(false);
                });
        }
    };

    const actUser = (email) => {
        let cds_token = getCookie("CDS_token");
        let SF_user = email;

        if (cds_token && SF_user) {
            dispatch(loadUser(SF_user, "cent2021")).then((result) => {
                
                if (!result) {
                    setTimeout(function () {
                        dispatch(loadUser(SF_user, "cent2021")).then((result) => {
                            
                            if (!result) {
                                alert("Error loading user 2");
                            } else if (result.Error) {
                                alert("Error loading user 3");
                            }
                        });
                    }, 2000);
                } else if (result.Error) {
                    alert("Error loading user");
                }
            });
        }
    };

    const deleteUser = () => {};
    const saveUser = () => {
        if (currentUserId && currentUser) {
            let errors_has_content = checkDoesObjectHaveContent(errorStateUser);

            if (errors_has_content) {
                setShowMessage({
                    type: "error",
                    message: "Error: User " + errors_has_content.key + " " + errors_has_content.value,
                });
                return;
            }

            let api_url = API_BASE() + "user/" + btoa(currentUser.id);
            setLoading(true);
            fetchTimeout(api_url, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(currentUser),
            })
                .then((response) => response.json())
                .then((json) => {
                    
                    //get users
                    api_url = API_BASE() + "users/" + currentBusinessId;
                    fetchTimeout(api_url, {
                        method: "GET",
                    })
                        .then((response) => response.json())
                        .then((json) => {
                            
                            setCurrentBusinessUsers(json);
                            setLoading(false);
                        })
                        .catch((e) => {
                            
                            setCurrentBusinessUsers(null);
                            setLoading(false);
                        });
                })
                .catch((e) => {
                    
                    setLoading(false);
                });
        }
    };

    const updateNewUser = (param) => (e, value) => {
        let val = value ? value : e;
        if (val?.target?.value) val = e?.target?.value;

        let updateUser = deepCopy(currentUser);
        updateUser[param] = val;
        setCurrentUser(updateUser);

        // validate using customer validation schema
        if (validationSchema?.Customer?.[param]) {
            let error = "";
            error = checkJobStateValidationSchema(validationSchema, "Customer", null, param, val);
            let newErrorState = deepCopy(errorStateUser);
            newErrorState[param] = error;
            setErrorStateUser(newErrorState);
        }
    };

    const updateSuggestion = (name) => {
        setBusinessName(name);
        let name_trimmed = name.trim().toUpperCase();
        let split = name_trimmed.split(" ");
        let first = name_trimmed.length > 0 ? name_trimmed[0] : "X";
        let second = name_trimmed.length > 1 ? name_trimmed[1] : "X";
        let third = name_trimmed.length > 2 ? name_trimmed[2] : "X";

        if (split.length > 2) {
            second = split[1][0];
            third = split[2][0];
        } else if (split.length > 1) {
            third = split[1][0];
        }

        let code = first + second + third;
        let taken = false;

        for (var item of allbusinessList) {
            if (item.id === code) taken = true;
        }

        if (taken) {
            let first = name_trimmed.length > 0 ? name_trimmed[0] : "X";
            let second = name_trimmed.length > 1 ? name_trimmed[1] : "X";
            let third = name_trimmed.length > 2 ? name_trimmed[2] : "X";
            code = first + second + third;
            taken = false;

            for (var item of allbusinessList) {
                if (item.id === code) taken = true;
            }

            if (taken) {
                let first = name_trimmed.length > 0 ? name_trimmed[0] : "X";
                let second = name_trimmed.length > 1 ? name_trimmed[1] : "X";
                let third = name_trimmed.length > 2 ? name_trimmed[2] : "X";
                code = first + second + third;
                taken = false;

                for (var item of allbusinessList) {
                    if (item.id === code) taken = true;
                }

                if (taken) {
                    let first = name_trimmed.length > 0 ? name_trimmed[0] : "X";
                    let second = name_trimmed.length > 2 ? name_trimmed[2] : "X";
                    let third = name_trimmed.length > 2 ? name_trimmed[name_trimmed.length - 1] : "X";
                    code = first + second + third;
                    taken = false;

                    for (var item of allbusinessList) {
                        if (item.id === code) taken = true;
                    }

                    if (taken) {
                        let first = name_trimmed.length > 0 ? name_trimmed[0] : "X";
                        let second = name_trimmed.length > 2 ? name_trimmed[2] : "X";
                        let third = name_trimmed.length > 2 ? name_trimmed[name_trimmed.length - 1] : "X";

                        if (split.length > 2) {
                            second = split[1][0];
                            third = split[2][split[2].length - 1];
                        } else if (split.length > 1) {
                            third = split[1][split[1].length - 1];
                        }

                        code = first + second + third;
                        taken = false;

                        for (var item of allbusinessList) {
                            if (item.id === code) taken = true;
                        }
                    }
                }
            }
        }

        if (!taken) {
            setCodeSuggestion(code.toUpperCase());
        } else {
            setCodeSuggestion("---");
        }
    };

    const exportUsers = () => {
        setExporting(true);
        const apiUrl = API_BASE() + "users/all";

        fetchTimeout(apiUrl, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                const csvData = jsonToCSV(json);
                const currentDate = new Date();
                const dateString = currentDate.toISOString().split("T")[0];
                const filename = `user_data_${dateString}.csv`;
                setExporting(false);
                downloadCSV(csvData, filename);
            })
            .catch((e) => {
                setExporting(false);
                console.error("User export error", e);
            });
    };

    function jsonToCSV(jsonData, headers) {
        // Use keys from the first object as headers if headers aren't provided
        if (!headers && jsonData.length > 0) {
            headers = Object.keys(jsonData[0]);
        }

        // Map the headers to a CSV string
        const csvRows = [
            headers.join(","), // Join headers to create the first row
            ...jsonData.map((row) => headers.map((fieldName) => JSON.stringify(row[fieldName] || "")).join(",")), // Map each json object to a CSV row
        ];

        return csvRows.join("\n");
    }

    function downloadCSV(csvData, filename = "export.csv") {
        const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    }

    React.useEffect(() => {
        if (currentUserId) {
            let api_url = API_BASE() + "user/" + btoa(currentUserId) + "/cent2021";
            setLoading(true);
            setCurrentUser(null);
            setErrorStateUser({});

            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    
                    setCurrentUser(json);
                    setLoading(false);
                })
                .catch((e) => {
                    
                    setLoading(false);
                });
        } else {
            setCurrentUser(null);
            setErrorStateUser({});
        }
    }, [currentUserId]);

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "business?isAdmin=" + isAdmin;
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    
                    setAllBusinessList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    
                    setAllBusinessList([]);
                });
        }
    }, [intialise]);

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "business/";
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    
                    setBusinessList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    
                    setBusinessList([]);
                });
        }
    }, [intialise]);

    let roleTypes = [
        { Key: 10, Display: "Dealer Admin" },
        { Key: 0, Display: "Dealer Standard" },
    ];

    if (currentBusiness) {
        if (user.Role >= 90 && currentBusiness.Type === "BBC") roleTypes.unshift({ Key: 90, Display: "BBC Standard" });
        if (user.Role >= 98 && currentBusiness.Type === "BBC")
            roleTypes.unshift({ Key: 91, Display: "BBC State Admin" });
        if (user.Role >= 99 && (currentBusiness.Type === "Engineer" || currentBusiness.Type === "BBC"))
            roleTypes.unshift({ Key: 99, Display: "BBC Super" });
        if (currentBusiness.Type === "Engineer") roleTypes = [{ Key: 92, Display: "Engineer" }];
    }

    let businessesSorted = [];
    businessesSorted.push({ disabled: true, Key: "[BBC]", Display: "[BBC Licenses]" });
    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && item.Type === "BBC")
            businessesSorted.push({ Key: item.id, Display: item.id + "-" + item.Name });
    }

    businessesSorted.push({ disabled: true, Key: "[Engineers]", Display: "[Engineers Licenses]" });
    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && item.Type === "Engineer")
            businessesSorted.push({ Key: item.id, Display: item.id + "-" + item.Name });
    }

    businessesSorted.push({ disabled: true, Key: "[Customers]", Display: "[Customers Licenses]" });
    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && (!item.Type || (item.Type !== "Engineer" && item.Type !== "BBC")))
            businessesSorted.push({ Key: item.id, Display: item.id + "-" + item.Name });
    }

    businessesSorted.push({ disabled: true, Key: "[Archived]", Display: "[Archived Licenses]" });
    for (var item of businessList) {
        if (item.Status === "ARCHIVED")
            businessesSorted.push({
                Key: item.id,
                Display: (
                    <span style={{ color: "red" }}>
                        <em>{item.id + "-" + item.Name}</em>
                    </span>
                ),
            });
    }

    return (
        <div className={classes.root}>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionRow style={{ borderBottom: "1px solid grey" }}>
                    <BSL_Select
                        label={"Business License"}
                        style={{ flex: 2, maxWidth: "600px" }}
                        value={currentBusinessId}
                        tight={true}
                        items={businessesSorted}
                        onChange={(e) => {
                            setCurrentBusinessId(e.target.value);
                        }}
                    />

                    <BSL_Button
                        label="SUGGEST CDS Account Code"
                        onClick={() => setShowCodeGenerator(true)}
                        style={{
                            maxWidth: "300px",
                            maxHeight: "32px",
                            alignSelf: "end",
                            marginLeft: "72px",
                            marginBottom: "7px",
                        }}
                    />

                    <BSL_Button
                        label="Export User Data"
                        disabled={exporting}
                        onClick={exportUsers}
                        style={{
                            maxWidth: "300px",
                            maxHeight: "32px",
                            alignSelf: "end",
                            marginLeft: "72px",
                            marginBottom: "7px",
                        }}
                    />

                    <div style={{ flex: 1 }} />
                </BSL_Common.SectionRow>
                {loading && <LinearProgress />}
                {currentBusiness && (
                    <div
                        style={{
                            display: "flex",
                            overflow: "auto",
                            textAlign: "left",
                            paddingRight: "10px",
                            flexDirection: "column",
                        }}
                    >
                        <BSL_Common.SectionRow
                            style={{
                                width: "98%",
                            }}
                        >
                            <BSL_Common.SectionContainer
                                style={{
                                    paddingRight: "10px",
                                    flex: 1,
                                }}
                            >
                                <ManageBusiness
                                    BusinessDetails={currentBusiness}
                                    UpdateBusiness={setCurrentBusiness}
                                    ErrorState={errorStateBusiness}
                                    SetErrorState={setErrorStateBusiness}
                                    admin={true}
                                    setSaveButtonDisabled={setSaveButtonDisabled}
                                />
                                <BSL_Common.SectionRow>
                                    {currentBusiness?.Status !== "ARCHIVED" && (
                                        <BSL_Button
                                            label="Save Business Detail Changes"
                                            onClick={saveBusiness}
                                            style={{ margin: "10px" }}
                                            disabled={saveButtonDisabled}
                                        />
                                    )}
                                    <BSL_Button
                                        secondary={currentBusiness?.Status !== "ARCHIVED"}
                                        label={
                                            currentBusiness?.Status === "ARCHIVED"
                                                ? "Unarchive Business"
                                                : "Archive Business"
                                        }
                                        onClick={() => setShowArchiveBusiness(true)}
                                        style={{ margin: "10px" }}
                                    />
                                </BSL_Common.SectionRow>

                                {loading && <LinearProgress />}
                            </BSL_Common.SectionContainer>

                            <BSL_Common.SectionContainer
                                style={{
                                    flex: 1,
                                    paddingLeft: "10px",
                                    background: "#f2f2f2",
                                    borderLeft: "1px solid grey",
                                }}
                            >
                                <BSL_Common.SectionHeader>Manage Users</BSL_Common.SectionHeader>
                                <SegmentedButtonGroup
                                    ButtonGroupStyle={{
                                        flexWrap: "wrap",
                                    }}
                                    style={{ flex: "none" }}
                                    value={currentUserId}
                                    items={
                                        currentBusinessUsers
                                            ? currentBusinessUsers.map((user) => {
                                                  return {
                                                      Key: user.id,
                                                      Display:
                                                          user.FirstName + (user.LastName ? " " + user.LastName : ""),
                                                  };
                                              })
                                            : []
                                    }
                                    onChange={(e, val) => {
                                        setCurrentUserId(val);
                                    }}
                                />

                                {currentUserId && currentUser && (
                                    <BSL_Common.SectionContainer
                                        style={{
                                            padding: "10px",
                                            flex: 1,
                                        }}
                                    >
                                        Editing Details for{" "}
                                        {currentUser.FirstName +
                                            (currentUser.LastName ? " " + currentUser.LastName : "")}
                                        <BSL_Common.SectionContainer>
                                            <BSL_Common.SectionHeader>User Settings</BSL_Common.SectionHeader>

                                            <BSL_Common.SectionRow>
                                                <SegmentedButtonGroup
                                                    tight
                                                    label="Status"
                                                    ButtonGroupStyle={{
                                                        flexWrap: "wrap",
                                                    }}
                                                    style={{ flex: "none" }}
                                                    value={currentUser?.Status}
                                                    items={
                                                        currentUser?.Status === "ARCHIVED"
                                                            ? ["ARCHIVED"]
                                                            : ["ACTIVE", "DEACTIVATED"]
                                                    }
                                                    onChange={updateNewUser("Status")}
                                                />
                                            </BSL_Common.SectionRow>
                                            <BSL_Common.SectionRow>
                                                <BSL_TextInput
                                                    label="Display Name"
                                                    preValidate="name"
                                                    tight
                                                    disabled
                                                    value={currentUser.DisplayName}
                                                    onBlur={updateNewUser("DisplayName")}
                                                    error={errorStateUser?.DisplayName}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                                <BSL_TextInput
                                                    label="First Name"
                                                    preValidate="name"
                                                    tight
                                                    disabled
                                                    value={currentUser.FirstName}
                                                    onBlur={updateNewUser("FirstName")}
                                                    error={errorStateUser?.FirstName}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                                <BSL_TextInput
                                                    label="Last Name"
                                                    preValidate="name"
                                                    tight
                                                    disabled
                                                    value={currentUser.LastName}
                                                    onBlur={updateNewUser("LastName")}
                                                    error={errorStateUser?.LastName}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                            </BSL_Common.SectionRow>

                                            {currentUser.Role <= user.Role && (
                                                <SegmentedButtonGroup
                                                    label="User Type"
                                                    ButtonGroupStyle={{
                                                        flexWrap: "wrap",
                                                    }}
                                                    style={{ flex: "none" }}
                                                    value={currentUser.Role}
                                                    disabled
                                                    items={roleTypes}
                                                    onChange={(e, val) => {
                                                        let updateUser = deepCopy(currentUser);
                                                        updateUser["Role"] = val;
                                                        updateUser["RoleName"] = "";
                                                        for (let role of roleTypes) {
                                                            if (role.Key === val) updateUser["RoleName"] = role.Display;
                                                        }
                                                        setCurrentUser(updateUser);
                                                    }}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                            )}

                                            <BSL_Common.SectionRow>
                                                <BSL_TextInput
                                                    label="Email"
                                                    tight
                                                    disabled
                                                    value={currentUser.Email}
                                                    onBlur={updateNewUser("Email")}
                                                    error={errorStateUser?.Email}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                                <BSL_TextInput
                                                    label="Phone"
                                                    tight
                                                    disabled
                                                    value={currentUser.Phone}
                                                    onBlur={updateNewUser("Phone")}
                                                    error={errorStateUser?.Phone}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                            </BSL_Common.SectionRow>

                                            <BSL_Common.SectionRow>
                                                <SegmentedButtonGroup
                                                    tight
                                                    label="Beta User"
                                                    ButtonGroupStyle={{ flexWrap: "wrap" }} // Maintain consistency in naming conventions
                                                    style={{ flex: "none" }} // Ensure styling aligns with its purpose
                                                    value={currentUser?.BetaUser} // Simplify value check
                                                    items={["true", "false"]}
                                                    onChange={updateNewUser("BetaUser")}
                                                />
                                            </BSL_Common.SectionRow>

                                            <BSL_Common.SectionRow>
                                                <BSL_TextInput
                                                    label="API KEY"
                                                    tight
                                                    disabled
                                                    value={currentUser?.apiKey}
                                                    onBlur={updateNewUser("apiKey")}
                                                    error={errorStateUser?.apiKey}
                                                />
                                            </BSL_Common.SectionRow>

                                            <BSL_Common.SectionRow
                                                style={{
                                                    padding: "20px",
                                                }}
                                            >
                                                <BSL_Button label="Save User Changes" onClick={saveUser} />
                                                <BSL_Button secondary label="Delete User" onClick={deleteUser} />
                                                {user.Role >= 99 && (
                                                    <BSL_Button
                                                        secondary
                                                        label="Act as User"
                                                        onClick={() => {
                                                            actUser(currentUser.Email);
                                                        }}
                                                    />
                                                )}
                                            </BSL_Common.SectionRow>
                                        </BSL_Common.SectionContainer>
                                    </BSL_Common.SectionContainer>
                                )}
                            </BSL_Common.SectionContainer>
                        </BSL_Common.SectionRow>
                    </div>
                )}
            </BSL_Common.SectionContainer>
            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />

            {showCodeGenerator && (
                <BSL_Dialog
                    title={"Suggest New CDS Code"}
                    open={showCodeGenerator}
                    onClose={() => setShowCodeGenerator(false)}
                    button1Text={"DONE"}
                    button1Click={() => setShowCodeGenerator(false)}
                >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <BSL_TextInput
                            label="Enter Business Name"
                            tight
                            value={businessName}
                            onBlur={(value) => updateSuggestion(value)}
                            onChange={(value) => updateSuggestion(value)}
                        />
                        <div
                            style={{
                                textAlign: "center",
                            }}
                        >
                            SUGGESTED CODE:
                            <br />
                            <div
                                style={{
                                    padding: "0px",
                                    border: "1px dotted #444444",
                                    borderRadius: "10px",
                                    fontSize: "38px",
                                    width: "50%",
                                    marginLeft: "25%",
                                }}
                            >
                                {codeSuggestion}
                            </div>
                        </div>
                    </div>
                </BSL_Dialog>
            )}

            {currentBusiness && showArchiveBusiness && (
                <BSL_Dialog
                    title={currentBusiness?.Status === "ARCHIVED" ? "Unarchive Business?" : "Archive Business?"}
                    open={showArchiveBusiness}
                    onClose={() => setShowArchiveBusiness(false)}
                    button1Text={currentBusiness?.Status === "ARCHIVED" ? "ACTIVE" : "ARCHIVED"}
                    button1Click={() => archiveBusiness(currentBusinessId)}
                    button2Text="No"
                    button2Click={() => setShowArchiveBusiness(false)}
                >
                    <div style={{ display: "flex" }}>
                        <div>
                            Are you sure you would like to{" "}
                            {currentBusiness?.Status === "ARCHIVED" ? "SET ACTIVE" : "ARCHIVE"} this Business (
                            {currentBusiness.Name})?
                        </div>
                    </div>
                </BSL_Dialog>
            )}

            {currentBusiness && showDeleteBusiness && (
                <BSL_Dialog
                    title="Delete Business"
                    open={showDeleteBusiness}
                    onClose={() => setShowDeleteBusiness(false)}
                    button1Text="IRREVERSIBLY DELETE"
                    button1Click={() => deleteBusiness(currentBusinessId)}
                    button2Text="No"
                    button2Click={() => setShowDeleteBusiness(false)}
                >
                    <div style={{ display: "flex" }}>
                        <div>
                            Are you sure you would like to IRREVERSIBLY DELETE this Business ({currentBusiness.Name})?
                        </div>
                    </div>
                </BSL_Dialog>
            )}
        </div>
    );
}